export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8482.49fa03a7.jpg";